import "@/scss/maeu.scss";
import App from "@/App.vue";
import { createApp } from "vue";
import pinia from "@/store/index";
import getRouter from "@/router/router";
import { MdsConfig } from "@maersk-global/mds-config";
import { environmentData } from "@/helper/environment";
import { LDPlugin } from "launchdarkly-vue-client-sdk";
import { type MaerskVueAppConfig } from "@maersk-global/vue-plugin-maerskvueapp";

const initializeApp = async () => {
  const app = createApp(App);
  app.use(pinia);
  app.use(getRouter());
  app.use(LDPlugin, {
    clientSideID: environmentData.LDClientID,
    options: {
      bootstrap: "localStorage"
    },
    user: {
      key: "anon", // anonymous users use the same key
      anonymous: true
    }
  });
  MdsConfig.iconsDynamicImportPath = "./";
  const config: MaerskVueAppConfig = {};
  config.designTokenRootPath = ".";
  config.SKIP_GLOBAL_NAV = true;
  app.config.compilerOptions.isCustomElement = (tag) => tag.startsWith("mc-");

  if (import.meta.env.DEV) {
    if (!import.meta.env.VITE_E2E) {
      MdsConfig.iconsDynamicImportPath = "../../";
    }
  }

  return app;
};

export default initializeApp;
